/**
 * Labstep
 *
 * @module components/Folder/Action/Remove
 * @desc Action to remove parentEntity to folder
 */

import { EntityActionRemove } from 'labstep-web/components/Entity/Action/Remove';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { ParamsContext } from 'labstep-web/contexts/params';
import { ParamsHOC } from 'labstep-web/hoc/Params';
import { Folder } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { FolderActionRemoveProps } from './types';

export const FolderActionRemove: React.FC<
  FolderActionRemoveProps
> = ({ parentId, parentName, actionComponentProps = {} }) => (
  <ParamsHOC historyAction="replace">
    <ParamsContext.Consumer>
      {({ searchParams }) =>
        'folder_id' in searchParams && (
          <EntityReadEntityContainer
            entityName={Folder.entityName}
            id={searchParams.folder_id as number}
          >
            {({ entity }) =>
              entity ? (
                <EntityActionRemove
                  noConfirmation
                  entity={null}
                  entityId={entity.id}
                  entityName={entity.entityName}
                  parentName={parentName}
                  parentId={parentId}
                  actionComponentProps={{
                    type: 'option',
                    text: 'Remove from collection',
                    ...actionComponentProps,
                  }}
                />
              ) : null
            }
          </EntityReadEntityContainer>
        )
      }
    </ParamsContext.Consumer>
  </ParamsHOC>
);
